// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1quBM","signatureBlock":"Footer_signatureBlock__1-SuW","signature":"Footer_signature__2A2Fg"};